
import { Navbar, Sidebar, AppMain } from './components';
// import { mapGetters } from 'vuex'
import calendarRouter from '@/router/modules/calendar';

export default {
  name: 'CalendarLayout',

  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain
  },

  data: function data() {
    return {
      calendarRouters: calendarRouter
    };
  },


  computed: {},

  created: function created() {},


  methods: {
    navClick: function navClick(index) {}
  }
};